import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledBox, StyledBoxAccessory } from './Box.style.js';

const Box = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    accessory,
    as,
    border,
    borderColor,
    children,
    className,
    color,
    grow,
    height,
    id,
    noMargin,
    overflow,
    padding: paddingFromProps,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    radius,
    radiusBottomLeft,
    radiusBottomRight,
    radiusTopLeft,
    radiusTopRight,
    role,
    shadow,
    ...rest
  } = _ref;
  const padding = typeof paddingFromProps === 'undefined' && typeof paddingBottom === 'undefined' && typeof paddingLeft === 'undefined' && typeof paddingRight === 'undefined' && typeof paddingTop === 'undefined' ? {
    xs: 'md',
    md: 'xl'
  } : paddingFromProps;
  return /*#__PURE__*/React__default.createElement(StyledBox, _extends({}, rest, {
    $border: border,
    $borderColor: borderColor,
    $color: color,
    $grow: grow,
    $height: height,
    $overflow: overflow,
    $radius: radius,
    $radiusBottomLeft: radiusBottomLeft,
    $radiusBottomRight: radiusBottomRight,
    $radiusTopLeft: radiusTopLeft,
    $radiusTopRight: radiusTopRight,
    $shadow: shadow,
    className: className,
    forwardedAs: as,
    id: id,
    marginBottom: noMargin ? 'none' : 'lg',
    padding: padding,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    ref: ref,
    role: role
  }), children, accessory && /*#__PURE__*/React__default.createElement(StyledBoxAccessory, null, accessory));
});
const SIZES = ['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'layout-xxs', 'layout-xs', 'layout-sm', 'layout-md', 'layout-lg', 'layout-xl', 'layout-xxl'];
Box.displayName = 'Box';
Box.propTypes = {
  /**
   * Component rendered over top-right corner, ie. Switch.
   */
  accessory: PropTypes.node,
  /**
   * Element used for the root node.
   */
  // @ts-expect-error
  as: PropTypes.elementType,
  border: PropTypes.oneOf(['dashed', 'none']),
  /**
   * Color of the border. Primarily for internal use.
   */
  borderColor: PropTypes.oneOf(['danger', 'dark', 'disabled', 'secondary']),
  /**
   * Content of the component. Primarily for internal use.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Color of the background.
   */
  color: PropTypes.oneOf(['light', undefined]),
  grow: PropTypes.bool,
  height: PropTypes.number,
  id: PropTypes.string,
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool,
  overflow: PropTypes.oneOf(['auto', 'hidden']),
  // @ts-expect-error
  padding: PropTypes.oneOfType([PropTypes.oneOf([0]), PropTypes.string, PropTypes.object, PropTypes.oneOf(SIZES)]),
  // @ts-expect-error
  paddingBottom: PropTypes.oneOfType([PropTypes.oneOf([0]), PropTypes.string, PropTypes.object, PropTypes.oneOf(SIZES)]),
  // @ts-expect-error
  paddingLeft: PropTypes.oneOfType([PropTypes.oneOf([0]), PropTypes.string, PropTypes.object, PropTypes.oneOf(SIZES)]),
  // @ts-expect-error
  paddingRight: PropTypes.oneOfType([PropTypes.oneOf([0]), PropTypes.string, PropTypes.object, PropTypes.oneOf(SIZES)]),
  // @ts-expect-error
  paddingTop: PropTypes.oneOfType([PropTypes.oneOf([0]), PropTypes.string, PropTypes.object, PropTypes.oneOf(SIZES)]),
  radius: PropTypes.oneOf(['none', 'md', 'lg', 'circle', 'pill']),
  radiusBottomLeft: PropTypes.oneOf(['none', 'md', 'lg', 'circle', 'pill']),
  radiusBottomRight: PropTypes.oneOf(['none', 'md', 'lg', 'circle', 'pill']),
  radiusTopLeft: PropTypes.oneOf(['none', 'md', 'lg', 'circle', 'pill']),
  radiusTopRight: PropTypes.oneOf(['none', 'md', 'lg', 'circle', 'pill']),
  role: PropTypes.string,
  shadow: PropTypes.oneOf(['default', 'modal', undefined])
};

export { Box };
